import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { ValidationService } from 'src/app/services/validation.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { IConfirmDialogData } from 'src/app/components/dialog/dialog.data';
import * as Constants from "../../../../constant/Constants";
import { ConfirmComponent } from 'src/app/components/dialog/confirm/confirm.component';
import { ApiCallService } from 'src/app/api/service/api-call.service';
import { checkArrayIsObject, checkArrayStringType } from 'src/app/util/HelperFunctions';

@Component({
  selector: 'app-page-four',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.css']
})
export class ClaimComponent implements OnInit {

  // Url Params
  claim: string = 'windscreen';  // windscreen, entertainemt, own, theft ... etc.
  type: string = 'rep';  // Windscreen [rep, no-rep], Theft [total, partial], ... etc.
  form: string = 'garage, glazier, bank';
  id: string = 'none';
  token: string = "placeholder-value"; // to validate the public accesses.

  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  BanksPlaceHolders: any = [];

  BranchPlaceHolders: any = [];

  RegionPlaceHolders: any = [];

  GlazierPlaceHolders: any = []

  GaragePlaceHolders: any = [];

  garageOptionA: string = 'SELECT A GARAGE FROM OUR APPROVED PANEL';
  garageOptionB: string = 'OTHER GARAGE (MY PREFERRED GARAGE)';

  garagePhone: string = '+254 XXX XXXXXX';

  GarageOptions: any = [
    this.garageOptionA,
    this.garageOptionB
  ];
  

  pageHeading: string = 'Damage Claim Form';
  pageHeadingSuffix: string = ' Claim Form (Continued)';

  bankDetailsTitle: string = 'Enter your Bank Details';
  bankLabel: string = 'Select Bank';
  branchLabel: string= 'Select Branch';
  accountNameLabel: string = 'Account Name';
  accountNameHint: string = 'Your personal account name';
  accountNumLabel: string = 'Account Number';
  accountNumHint: string = 'Your personal account number';
  attachDocText: string = 'Attach copy of atm or bank cheque leaf (Optional)';

  regionLabel: string = 'Select Region';
  glazierLabel: string = 'Select Glazier Region';

  garageOptionLabel: string = 'Where would you like to take your vehicle?';
  garageLabel: string = 'Select Garage';
  garageNameLabel: string = 'Garage Name';
  garageTelLabel: string = 'Telephone Number';
  garageTelHint: string = 'The garage\'s telephone number';
  fullNameLabel: string = 'Your Full Name';
  dateLabel: string = 'Date';
  iSwearText: string = 'I hereby declare that these particulars are true, and undertake to forward immediately (if any, unanswered), correspondence relating to this accident.';

  cancelText: string = 'Cancel';
  saveText: string = 'Save and Continue';

  requiredString: string = 'This field is required';
  namePlaceHolder: string = '';

  showPopup: boolean = false;
  errorText: string = 'Please attach a .JPG or .PDF File';
  errorString: string = this.errorText;

  motorFormContinued = this._formBuilder.group({
    bank: ["", Validators.required],
    branch: ["", Validators.required],
    accountName: ["", Validators.required],
    accountNum: ["", Validators.required],

    region: ["", Validators.required],
    // glazier: ["", Validators.required],
    garageOption: [""],
    garage: [],
    garageName: [""],
    garageTel: [""],
    name: ["", [Validators.required, Validators.pattern(/^.+ .+/)]],
    date: [moment(), Validators.required],
    iSwear: [false],

  });
  formErrors:{[key:string]:string}= {
    bank:'',
    branch:'',
    accountName:'',
    accountNum:'',
    region:'',
    // glazier:'',
    garage: '',
    garageOption: '',
    garageName: '',
    garageTel: '',
    name:'',
    date:'',
    iSwear: '',
  }
  validationMessages:{[key:string]:{[key:string]:string}}= {
    bank:{required: this.requiredString },
    branch:{required: this.requiredString },
    accountName:{required: this.requiredString },
    accountNum: {required: this.requiredString },
    region: {required: this.requiredString },
    // glazier: {required: this.requiredString },
    garageOption: {required: this.requiredString },
    garageName: {required: this.requiredString },
    garageTel: {required: this.requiredString },
    garage: {required: this.requiredString },
    name: {required: this.requiredString, pattern: 'Please enter your Full Name' },
    date: {required: this.requiredString },
  }

  minDate: Date;
  maxDate: Date;

  url: string = environment.baseUrl + Constants.claimFormURL;
  loading: boolean = false;

  atmOrChequeDoc: any = "";
  docSuffix: any = "";
  uploadText: string = this.attachDocText;
  uploadIcon: string = "add_a_photo";
  docName: string = '';
  
  constructor(private route: ActivatedRoute,
    private _formBuilder:FormBuilder,
    private validationService:ValidationService,
    public dialog: MatDialog,
    private apiCallService: ApiCallService,
    ) {
    const currentDate = new Date();
    const tempDate = new Date(currentDate.getTime());

    tempDate.setFullYear(currentDate.getFullYear() - 10)

    this.minDate = tempDate;
    this.maxDate = currentDate;
   }

   altView: boolean = false;
   loadingRegions: boolean = false;
   loadingBanks: boolean = false;
   loadingBankBranches: boolean = false;
   loadingGlaziers: boolean = false;
   loadingGarages: boolean = false;

   regionsIsEmpty: boolean = true;
   banksIsEmpty: boolean = true;
   branchesIsEmpty: boolean = true;
  //  glaziersIsEmpty: boolean = true;
   garagesIsEmpty: boolean = true;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;

      if (params['claim'] !== undefined) {
        this.claim = params['claim'];
      }
      if (params['type'] !== undefined) {
        this.type = params['type'];
      }
      if (params['form'] !== undefined) {
        this.form = params['form'];

        if (this.form === 'garage') {
          if (params['claim'] === 'windscreen') {
            this.pageHeading = 'Windscreen Damage Claim';
  
          } else if (params['claim'] === 'entertainment') {
            this.pageHeading = 'Entertainment/Radio Unit Claim';
          } else if (params['claim'] === 'theft') {
            if (this.type === 'total') {
              this.pageHeading = 'Total Loss - Theft Claim';
            } else {
              this.pageHeading = 'Partial Theft Claim';
            }
          } else if (params['claim'] === 'fire') {
            this.pageHeading = 'Fire Damage Claim';
          }else if (params['claim'] === 'flood') {
            this.pageHeading = 'Flood Damage Claim';
          }

          this.getRegionsList();
        } else {
          if (params['claim'] === 'windscreen') {
            this.pageHeading = 'Windscreen Damage' + this.pageHeadingSuffix;
  
          } else if (params['claim'] === 'entertainment') {
            this.pageHeading = 'Entertainment/Radio Unit' + this.pageHeadingSuffix;
          }else if (params['claim'] === 'theft') {
            if (this.type === 'total') {
              this.pageHeading = 'Total Loss - Theft' + this.pageHeadingSuffix;
            } else {
              this.pageHeading = 'Partial Theft' + this.pageHeadingSuffix;
            }
          } else if (params['claim'] === 'fire') {
            this.pageHeading = 'Fire Damage' + this.pageHeadingSuffix;
          }else if (params['claim'] === 'flood') {
            this.pageHeading = 'Flood Damage' + this.pageHeadingSuffix;
          }

          if (this.form === "bank") {
            this.getBanksList();
          } else if (this.form === "glazier") {
            this.getRegionsList();
          }
        }
      }
      if (params['id'] !== undefined) {
        this.id = params['id'];

        this.getPolicyDetails();
      }

    });

    this.motorFormContinued.valueChanges.subscribe((form) => {
      this.logErrors();

      if (this.form === 'garage') {
        this.motorFormContinued.controls['accountName'].setErrors(null);
        this.motorFormContinued.controls['accountNum'].setErrors(null);
        this.motorFormContinued.controls['name'].setErrors(null);
        this.motorFormContinued.controls['date'].setErrors(null);
        // this.motorFormContinued.controls['glazier'].setErrors(null);
        this.motorFormContinued.controls['bank'].setErrors(null);
        this.motorFormContinued.controls['branch'].setErrors(null);
      } else if (this.form === 'glazier') {
        this.motorFormContinued.controls['accountName'].setErrors(null);
        this.motorFormContinued.controls['accountNum'].setErrors(null);
        this.motorFormContinued.controls['garage'].setErrors(null);
        this.motorFormContinued.controls['bank'].setErrors(null);
        this.motorFormContinued.controls['branch'].setErrors(null);
      } else if (this.form === 'bank') {
        this.motorFormContinued.controls['garage'].setErrors(null);
        // this.motorFormContinued.controls['glazier'].setErrors(null);
        this.motorFormContinued.controls['region'].setErrors(null);
      }

      if (form.name) {
        this.motorFormContinued.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          name: form.name.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.bank) {
        this.motorFormContinued.patchValue({
          bank: form.bank.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      // if (form.branch) {
      //   this.motorFormContinued.patchValue({
      //     garage: form.branch.replace(/[a-z]/g, (match) => match.toUpperCase())
      //   }, {emitEvent: false});
      // }
      if (form.accountName) {
        this.motorFormContinued.patchValue({
          accountName: form.accountName.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      if (form.garageName) {
        this.motorFormContinued.patchValue({
          garageName: form.garageName.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.garageTel) {
        this.motorFormContinued.patchValue({
          garageTel: form.garageTel.replace(/[a-z]/g, '')
        }, {emitEvent: false});
      }
    });

    this.validationService.addOrRemoveValidationDependentGarageOnly(
      this.motorFormContinued.get("garageOption")!,
      "garage",
      this.motorFormContinued,
      this.garageOptionA,
    );
    this.validationService.addOrRemoveValidationDependentGarageOnly(
      this.motorFormContinued.get("garageOption")!,
      "garageName",
      this.motorFormContinued,
      this.garageOptionB,
    );
    this.validationService.addOrRemoveValidationDependentGarageOnly(
      this.motorFormContinued.get("garageOption")!,
      "garageTel",
      this.motorFormContinued,
      this.garageOptionB,
    );
  }

  async getPolicyDetails() {
    try {
      const dat = {
        id: this.id
      };
      const response = await this.apiCallService.postRequest(
        environment.baseUrl + Constants.policyDetailsURL, dat);

      if (response.error) {
        console.log(':Get details ERROR :: ', response);
      } else {
        this.namePlaceHolder = response.body.name;
        this.motorFormContinued.get('name')?.setValue(this.namePlaceHolder);
      }
    } catch (error) {
      console.log(':Details ERROR !! :: ', error);
    }
  }

  async getRegionsList() {
    this.loadingRegions = true;
    const response = await this.apiCallService.getRequest(
      environment.baseUrl + Constants.regionsURL
    );

    const isResponseValid = checkArrayStringType(response);

    if (isResponseValid) {
      this.RegionPlaceHolders = response;
      this.regionsIsEmpty = false;
      this.loadingRegions = false;
    } else {
      this.loadingRegions = false;
    }
  }
  
  async getBanksList() {
    this.loadingBanks = true;
    const response = await this.apiCallService.getRequest(
      environment.baseUrl + Constants.banksURL
    );

    const isResponseValid = checkArrayIsObject(response);

    if (isResponseValid) {
      this.BanksPlaceHolders = response;
      this.banksIsEmpty = false;
      this.loadingBanks = false;
    } else {
      this.loadingBanks = false;
    }
    
  }

  checkIfBankNameExists (value: string) {
    let bankID;
    
    for (var i = 0; i < this.BanksPlaceHolders.length; i++) {
      if (this.BanksPlaceHolders[i].BANKNAME === value) {
        bankID = this.BanksPlaceHolders[i].BANKID;
      }
    }
    return bankID;
  }

  async populateBankBranchesList() {
    this.BranchPlaceHolders = [];
    this.loadingBankBranches = true;
    
    const bankValue = this.motorFormContinued.controls["bank"].value;
    
    if (bankValue !== null) {
      const bankID: string = this.checkIfBankNameExists(bankValue);
      
      const vhmodelRequest = {
        bankID: `${bankID}`,
      };
      const response = await this.apiCallService.postRequest(
        environment.baseUrl + Constants.bankBranchesURL,
        vhmodelRequest
      );

      const isResponseValid = checkArrayStringType(response);
      if (!isResponseValid) {
        this.branchesIsEmpty = true;
      } else {
        this.BranchPlaceHolders = response.filter(function(entry: string) { return entry.trim() != ''; }); // Trim empty string entries
        this.branchesIsEmpty = false;
      }
  
    }

    this.loadingBankBranches = false;
  }

  async populateGaragesList() {
    this.GaragePlaceHolders = [];
    this.loadingGarages = true;
    
    const regionValue = this.motorFormContinued.controls["region"].value;
      
      const gmodelRequest = {
        regionName: regionValue,
      };

      const response = await this.apiCallService.postRequest(
        environment.baseUrl + Constants.garagesURL,
        gmodelRequest
      );

      if (response.length > 0) {
        this.GaragePlaceHolders = response;
        this.garagesIsEmpty = false;
      } else {
        this.garagesIsEmpty = true;
      }

      // const isResponseValid = checkArrayStringType(response);
      // if (!isResponseValid) {
      //   this.garagesIsEmpty = true;
      // } else {
      //   this.GaragePlaceHolders = response.filter(function(entry: string) { return entry.trim() != ''; }); // Trim empty string entries
      //   this.garagesIsEmpty = false;
      // }

    this.loadingGarages = false;
  }

  // async populateGlaziersList() {
  //   this.GlazierPlaceHolders = [];
  //   this.loadingGlaziers = true;
    
  //   const regionValue = this.motorFormContinued.controls["region"].value;
      
  //     const gmodelRequest = {
  //       regionName: regionValue,
  //     };
  //     const response = await this.apiCallService.postRequest(
  //       environment.baseUrl + Constants.glaziersURL,
  //       gmodelRequest
  //     );

  //     const isResponseValid = checkArrayStringType(response);
  //     if (!isResponseValid) {
  //       this.glaziersIsEmpty = true;
  //     } else {
  //       this.GlazierPlaceHolders = response.filter(function(entry: string) { return entry.trim() != ''; }); // Trim empty string entries
  //       this.glaziersIsEmpty = false;
  //     }

  //   this.loadingGlaziers = false;
  // }

  logErrors(){
    this.validationService.logValidationErrors(this.motorFormContinued,this.formErrors,this.validationMessages)
  }

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    let garageHolder = this.motorFormContinued.controls["garage"].value as unknown as { tel: string, name: string };

    if (garageHolder !== null) this.garagePhone = garageHolder.tel;

    if (this.motorFormContinued.controls["garageOption"].value === this.garageOptionB) {
      if (this.motorFormContinued.controls["garageName"].value !== null) {
        garageHolder = {
          name: this.motorFormContinued.controls["garageName"].value || '',
          tel: ''
        };
      }

      
    }

    const req = {
      formType: this.form,
      bank: this.motorFormContinued.controls["bank"].untouched ? null : this.motorFormContinued.controls["bank"].value,
      branch: this.motorFormContinued.controls["branch"].untouched ? null : this.motorFormContinued.controls["branch"].value,
      accountName: this.motorFormContinued.controls["accountName"].untouched ? null : this.motorFormContinued.controls["accountName"].value,
      accountNum: this.motorFormContinued.controls["accountNum"].untouched ? null : this.motorFormContinued.controls["accountNum"].value,
      region: this.motorFormContinued.controls["region"].untouched ? null : this.motorFormContinued.controls["region"].value,
      // glazier: this.motorFormContinued.controls["glazier"].untouched ? null : this.motorFormContinued.controls["glazier"].value,
      garageOption: this.motorFormContinued.controls["garageOption"].value,
      garage: garageHolder && garageHolder.name ? garageHolder.name : '',
      garageTel: this.motorFormContinued.controls["garageOption"].value === this.garageOptionB ? this.motorFormContinued.controls["garageTel"].value : garageHolder && garageHolder.tel ? garageHolder.tel : '',
      name: this.motorFormContinued.controls["name"].untouched ? null : this.motorFormContinued.controls["name"].value,
      date: this.motorFormContinued.controls["date"].untouched ? null : this.motorFormContinued.controls["date"].value,
      attachment: this.atmOrChequeDoc,
      attachmentSuffix: this.docSuffix,
      token: this.token,
      filled: true,
    };

    try {
      // Update form data (POST)
      const response = await this.apiCallService.postRequest(
        `${this.url}?token=${this.token}`, req
      ); // url to change for UG?
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
  }

  countdownAndSetFalse(): void {
    this.showPopup = true;

    setTimeout(() => {
      this.showPopup = false;
    }, 4000); // 5000 milliseconds = 5 seconds
  
    console.log("Countdown started...");
  }

  openImageDialog(event: any): void {
    const file = event.target.files[0];
    // console.log('File : ', file);
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result ? reader.result.toString().split(',')[1] : null;
      // console.log(base64String);
      
      // Check the file size here
      const maxSizeInBytes = 10 * 1024 * 1024; // 10MB (you can adjust this value)
      const fileSizeInBytes = file.size;
      
      if (fileSizeInBytes <= maxSizeInBytes) {

        // Get the file extension (suffix)
        const fileNameParts = file.name.split('.');
        if (fileNameParts.length > 1) {
          this.docSuffix = fileNameParts.pop(); // Get and set the file extension

          let suff = this.docSuffix.toUpperCase();
          console.log('GGG ?? ', suff);

          if (suff === 'PDF' || suff === 'JPG') {
            this.atmOrChequeDoc = base64String;
            this.docName = file.name;
            this.uploadIcon = 'description';

          } else {
            this.errorString = this.errorText;
            this.countdownAndSetFalse();

          }
        } else {
          this.docSuffix = ''; // Handle files with no extension
        }
        
      } else {
        // Display an error message or handle the oversized file in some way
        console.log("Selected document exceeds the maximum size limit.");

        this.errorString = 'Selected document exceeds the maximum size limit (10 MB)';
        this.countdownAndSetFalse();
        // TODO: toast
      }
    };
    reader.readAsDataURL(file);
  }

  clearImage(): void {
    this.docName = '';
    this.atmOrChequeDoc = '';
    this.uploadIcon = 'add_a_photo';
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'Are you sure you want to cancel the application?',
      'back',
      'Cancel application'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }
}
